function velocityPerFrame(xps, frameDuration) {
    return xps / (1000 / frameDuration);
}

export { velocityPerFrame };
